import { useOnInView } from "react-intersection-observer";

type Options = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isPaused?: boolean;
  fetchNextPage: () => unknown;
};

export const useLoadMoreOnVisible = ({
  hasNextPage,
  isFetchingNextPage,
  isPaused = false,
  fetchNextPage
}: Options) =>
  useOnInView(
    (inView) => {
      if (inView) fetchNextPage();
    },
    {
      rootMargin: "0px 0px 120px 0px",
      skip: !hasNextPage || isFetchingNextPage || isPaused
    }
  );
